// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useMemo } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { usePageVisibility } from 'features/common/hooks/usePageVisibility';

import type { AppDispatch, RootState } from './store';

// Use throughout your app instead of plain `useAppDispatch` and `useAppSelector`
// export const useAppDispatch: () => AppDispatch = useAppDispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function usePollingIntervalWhenVisible(intervalMs: number): number {
  const isVisible = usePageVisibility();

  return useMemo(() => {
    return isVisible ? intervalMs : 0;
  }, [isVisible, intervalMs]);
}
